import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { Observable } from 'rxjs/Rx';

import { Sensor } from './sensor';

import myGlobals = require('../config');

@Injectable()
export class SensorService {

  private sensorUrl = myGlobals.default.BASE_URL + '/sensor/';  // URL to web api

  constructor(private http: Http) { }

  //Obtener todos los sensors habilitados para el usuario
  getSensores() {
    return this.http.get(this.sensorUrl)
      .map((response) => response.json());
  }

  //Obtener un sensor
  getSensor(_id: string): Observable<Sensor> {
    return this.http.get(this.sensorUrl + _id)
      .map((response) => response.json());
  }

  //Obtener sensors by sucursal
  getSensoresBySucursal(_id: string) {
    return this.http.get(this.sensorUrl + "sucursal/" + _id)
      .map((response) => response.json());
  }

  save(sensor: Sensor): Observable<Sensor> {
    if (sensor._id) {
      return this.put(sensor);
    }
    //Seteo estado activo
    sensor.estado = true;
    return this.post(sensor);
  }

  //Desactivar sensor
  deleteSolo(sensor: Sensor) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.sensorUrl}/${sensor._id}`;

    return this.http
      .delete(url, { headers: headers })
      .map((response) => response.json());
  }

  //Desactivar sensor con body
  delete(sensor: Sensor) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.sensorUrl}/${sensor._id}`;

    return this.http
      .delete(url, { headers: headers })
      .map((response) => response.json());

  }

  // Agregar nuevo sensor
  private post(sensor: Sensor): Observable<Sensor> {
    let headers = new Headers({
      'Content-Type': 'application/json;charset=UTF-8'
    });
    headers.append('dataType', 'json');
    var sensorStr = JSON.stringify(sensor);
    return this.http
      .post(this.sensorUrl, sensorStr, { headers: headers })
      .map((response) => response.json());
  }

  // Actualizar sensor
  private put(sensor: Sensor) {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    let url = `${this.sensorUrl}/${sensor._id}`;

    return this.http
      .put(url, JSON.stringify(sensor), { headers: headers })
      .map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/sensor/sensor.service.ts